import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { hideFullOptions } from 'owa-options-core';
import { getStore } from '../store/store';

orchestrator(hideFullOptions, actionMessage => {
    let tasks = getStore().tasks;
    if (
        tasks &&
        GetStartedTaskId.ConfirmTimeZone in tasks &&
        actionMessage.subcategory === 'timeAndLanguage'
    ) {
        completeGetStartedTask(GetStartedTaskId.ConfirmTimeZone);
    }
});
